export default {"src":"/_next/static/media/instagram.e4d14b2f.svg","height":20,"width":21,"blurWidth":0,"blurHeight":0};